import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';

import { Property } from '../../../app/entities/property';
import { ListPropertiesPanel } from './list-properties-panel';
import { EditPropertyPanel } from './edit-property-panel';
import { View } from '../../../app/entities/view';

interface TaskPanelProps {
  targetId: string;
  view: View;
}

export const PropertiesPanel: React.FC<TaskPanelProps> = observer(({ view }) => {
  const [editingProperty, setEditingProperty] = useState<Property | null>(null);

  const handleEditProperty = (property: Property) => {
    setEditingProperty(property);
  };

  const handleBackToList = () => {
    setEditingProperty(null);
  };

  return editingProperty ? (
    <EditPropertyPanel property={editingProperty} onBackToList={handleBackToList} />
  ) : (
    <ListPropertiesPanel onEditProperty={handleEditProperty} view={view} />
  );
});
